import SellInInvoiceVsImeiScanCountTableBodyView from "./sell-in-invoice-vs-imei-scan-count-table-body.view";
import SellInInvoiceVsImeiScanCountTableHeaderView from "./sell-in-invoice-vs-imei-scan-count-table-header.view";

export default function SellInInvoiceVsScanCountTableView() {

  return {
    view: (vnode) => {

      const { tableData } = vnode.attrs;

      return m(".table-responsive",
        m("table.table.table-bordered.table-hover",
          m(SellInInvoiceVsImeiScanCountTableHeaderView, { tableData }),
          m(SellInInvoiceVsImeiScanCountTableBodyView, { tableData })
        )
      )
    }
  }
}